module.exports = __webpack_public_path__ + "static/img/evidence6.d64c51e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/evidence6.png
// module id = jMMk
// module chunks = 1 3